export default {
  namespaced: true,
  user_group_selection_option: {
    title: "Opções de Seleção de Grupos de Usuários",
    title_history: "Histórico de Opções de Seleção de Grupos de Usuários",
    user: "Usuário",
    email: "E-mail",
    groups: "Grupos",
    change: "Alterar",
    select: "Selecionar",
    without_groups: "Você não tem nenhum grupo atribuído",
    group: "Grupo",
    group_old: "Grupo anterior",
    date: "Data de alteração",
    bulk: {
      manage_users: "Gerenciar usuários",
      modal_title: "Gerenciar usuários por grupo",
      selected_groups: "grupo selecionado | grupos selecionados",
      manage_hint: "Gerencie os usuários autorizados antes de aplicar as alterações.",
      current_users: "Usuários nos grupos",
      currently_authorized: "Atualmente autorizados",
      remove_all: "Remover todos",
      loading: "Carregando...",
      remove_user: "Remover usuário",
      no_current_users: "Não há usuários atualmente.",
      users_to_add: "Usuários a adicionar",
      pending_add: "Adições pendentes",
      clear_add: "Limpar \"usuários a adicionar\"",
      cancel_add: "Cancelar adição",
      no_users_to_add: "Não há usuários para adicionar.",
      users_to_remove: "Usuários a remover",
      pending_remove: "Remoções pendentes",
      clear_remove: "Limpar \"usuários a remover\"",
      undo: "Desfazer",
      no_users_to_remove: "Não há usuários para remover.",
      users: "Usuários",
      search_users_hint: "Busque um ou mais usuários e escolha se deseja adicioná-los ou removê-los.",
      selected_users: "usuário selecionado | usuários selecionados",
      clear: "Limpar",
      add_selected: "Adicionar selecionados",
      remove_selected: "Remover selecionados",
      profile: "Perfil",
      profile_hint: "Gerencie todos os usuários pertencentes ao perfil selecionado.",
      select_profile: "Selecionar perfil",
      selected_profile: "Perfil selecionado:",
      remove_profile_single_hint: "Somente usuários que já estão no grupo serão considerados para remoção.",
      remove_profile_multiple_hint: "Todos os usuários do perfil serão considerados para remoção.",
      profile_add_to_add: "Colocar em \"usuários a adicionar\"",
      profile_remove_from_add: "Remover de \"usuários a adicionar\"",
      profile_add_to_remove: "Colocar em \"usuários a remover\"",
      profile_remove_from_remove: "Remover de \"usuários a remover\"",
      add_summary: "{count} usuário será adicionado a {groups}. | {count} usuários serão adicionados a {groups}.",
      group_count: "{count} grupo | {count} grupos",
      remove_summary: "{count} usuário está pendente de remoção. | {count} usuários estão pendentes de remoção.",
      apply_changes: "Aplicar alterações",
      user_fallback: "Usuário #{id}",
      all_selected_groups: "Todos os grupos selecionados",
      filters: "Filtros",
      clear_filters: "Limpar filtros",
      apply_filters: "Aplicar filtros",
      search_group: "Buscar grupo...",
      filtering_user: "Filtrando por usuário:",
      user_count: "usuário | usuários",
      authorized_users: "Usuários autorizados",
      loading_users: "Carregando usuários...",
      loading_more: "Carregando mais...",
      users_shown: "{count} de {total} usuários",
      no_authorized_users: "Nenhum usuário autorizado.",
      save_success: "Alterações salvas com sucesso",
      save_error: "Não foi possível salvar as alterações",
      filter_hint: "Selecione um usuário para mostrar apenas os grupos que ele pode selecionar.",
      active_filter: "Filtro ativo",
      load_error: "Erro ao carregar as informações",
      attach: "Adicionar usuários",
      attach_description: "Adicione os usuários selecionados aos grupos permitidos sem remover as atribuições existentes.",
      detach: "Remover usuários",
      detach_description: "Remova apenas os usuários selecionados dos grupos indicados.",
    },
  }
}